import { lazy, Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';

const ArtifactEditorPage = lazy(() => import('./pages/ArtifactEditorPage'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
  },
});

function StudioLoading() {
  return (
    <div className="h-screen flex items-center justify-center bg-slate-950 text-slate-400">
      <Loader2 className="w-6 h-6 animate-spin mr-2" />
      Loading studio…
    </div>
  );
}

export function ArtifactEditorRoute() {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<StudioLoading />}>
        <ArtifactEditorPage />
      </Suspense>
    </QueryClientProvider>
  );
}
